export function isPaidMember(membership) {
  return membership === "annual" || membership === "monthly" || membership === "canceled";
}